module.exports = __webpack_public_path__ + "static/media/logo.77cc81b4.png";